import React, { createContext, useContext, useState } from 'react';

const CompareContext = createContext();

const MAX_COMPARE = 3;

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);

  const addToCompare = (shed) => {
    setCompareList(prev => {
      if (prev.find(s => s.id === shed.id)) return prev;
      if (prev.length >= MAX_COMPARE) return prev;
      return [...prev, shed];
    });
  };

  const removeFromCompare = (shedId) => {
    setCompareList(prev => prev.filter(s => s.id !== shedId));
  };

  const isInCompare = (shedId) => compareList.some(s => s.id === shedId);

  const clearCompare = () => setCompareList([]);

  const compareCount = compareList.length;
  const canAddMore = compareList.length < MAX_COMPARE;

  return (
    <CompareContext.Provider value={{ compareList, addToCompare, removeFromCompare, isInCompare, clearCompare, compareCount, canAddMore }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
};
